import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaMapMarkerAlt, FaClock, FaUsers, FaCheck, FaCar, FaSuitcase, FaRoute, FaPlane, FaTimes } from "react-icons/fa";
import Swal from 'sweetalert2';
import axios from 'axios';
import config from '../../config';

export default function TransferListCard({ transfer, onBookNow, onAddToCart }) {
    const fallbackImage = "/assets/img/cars/car-06.jpg";
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [bookingData, setBookingData] = useState({
        flightNumber: '',
        arrivalTime: '',
        departureFlightNumber: '', // Round trip için
        departureTime: '' // Round trip için
    });

    // Vehicle type'a göre ikon belirle
    const getVehicleIcon = (vehicleType) => {
        switch(vehicleType?.toLowerCase()) {
            case 'car': return <FaCar className="me-1" />;
            case 'van': return <FaCar className="me-1" />;
            case 'bus': return <FaCar className="me-1" />;
            case 'minibus': return <FaCar className="me-1" />;
            default: return <FaCar className="me-1" />;
        }
    };

    // Vehicle category'ye göre renk belirle
    const getCategoryColor = (category) => {
        switch(category?.toLowerCase()) {
            case 'economy': return 'success';
            case 'standard': return 'primary';
            case 'premium': return 'warning';
            case 'luxury': return 'danger';
            default: return 'secondary';
        }
    };



    // Tarih formatını düzenleyen fonksiyon
    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleDateString('en-US', { month: 'short' });
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        } catch (error) {
            return dateString;
        }
    };

    // Transfer verilerini düzenle - yeni API response yapısına göre
    const transferData = {
        id: transfer.vehicleId,
        vehicleId: transfer.vehicleId,
        name: transfer.name || `${transfer.brand?.name || ''} ${transfer.model?.name || ''}`.trim(),
        vehicleCode: transfer.vehicleCode,
        vehicleType: transfer.vehicleType,
        vehicleCategory: transfer.vehicleCategory,
        minPassengers: transfer.minPassengers,
        maxPassengers: transfer.maxPassengers,
        baggageCapacity: transfer.baggageCapacity,
        brand: transfer.brand,
        model: transfer.model,
        routes: transfer.routes || [],
        route: transfer.route || (transfer.routes && transfer.routes.length > 0 ? transfer.routes[0] : null),
        pricing: transfer.pricing,
        dates: transfer.dates,
        passengers: transfer.passengers,
        offerKey: transfer.offerKey,
        // API'den gelen thumbnail URL'ini kullan, yoksa fallback image
        image: transfer.image || transfer.thumbnail || fallbackImage,
        isMultipleWay: transfer.routes && transfer.routes.length > 1,
        provider: transfer.brand?.name || 'Transfer Service'
    };

    // Modal açma fonksiyonu
    const handleBookNow = () => {
        setShowModal(true);
    };

    // Modal kapama fonksiyonu
    const handleCloseModal = () => {
        setShowModal(false);
        setBookingData({
            flightNumber: '',
            arrivalTime: '',
            departureFlightNumber: '',
            departureTime: ''
        });
    };

    // Form input değişikliklerini handle et
    const handleInputChange = (field, value) => {
        setBookingData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Rezervasyon onaylama fonksiyonu
    const handleConfirmBooking = async () => {
        // Validasyon
        if (!bookingData.flightNumber.trim()) {
            Swal.fire({
                title: 'Missing Information',
                text: 'Please enter your flight number',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (!bookingData.arrivalTime.trim()) {
            Swal.fire({
                title: 'Missing Information',
                text: 'Please enter your flight arrival time',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Round trip için ek validasyon
        if (transferData.pricing.isRoundTrip || transferData.isMultipleWay) {
            if (!bookingData.departureFlightNumber.trim()) {
                Swal.fire({
                    title: 'Missing Information',
                    text: 'Please enter your departure flight number',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            if (!bookingData.departureTime.trim()) {
                Swal.fire({
                    title: 'Missing Information',
                    text: 'Please enter your departure flight time',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }
        }

        setIsSubmitting(true);

        try {
            // User token kontrolü
            const userData = JSON.parse(localStorage.getItem('user_data'));
            if (!userData?.token) {
                Swal.fire({
                    title: 'Please Login',
                    text: 'You need to login to add items to cart',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                setIsSubmitting(false);
                return;
            }

            // Loading alert göster
            Swal.fire({
                title: 'Adding to Cart...',
                text: 'Please wait while we add your transfer to cart',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // API çağrısı için data hazırla
            const requestData = {
                offer_key: transferData.offerKey,
                type: "transfer",
                departure: {
                    flight_number: bookingData.flightNumber,
                    flight_time: bookingData.arrivalTime
                }
            };

            // Multiple way için return bilgilerini ekle
            if ((transferData.pricing.isRoundTrip || transferData.isMultipleWay) && bookingData.departureFlightNumber && bookingData.departureTime) {
                requestData.return = {
                    flight_number: bookingData.departureFlightNumber,
                    flight_time: bookingData.departureTime
                };
            }



            // API çağrısı
            const response = await axios.post(
                `${config.API_BASE_URL_V1}basket/add`,
                requestData,
                {
                    headers: {
                        'Authorization': `Bearer ${userData.token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );



            if (response.data.status === 'success') {
                // Sepete ekleme başarılı
                Swal.fire({
                    toast: true,
                    position: 'top-right',
                    title: 'Added to Cart!',
                    text: `${transferData.name} has been added to your cart`,
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });

                // Parent component'e bilgi ver (sticky cart için)
                if (onAddToCart) {
                    const cartItem = {
                        id: response.data.data.basket.basketItems[0]?.id,
                        type: 'transfer',
                        vehicleId: transferData.vehicleId,
                        name: transferData.name,
                        vehicleType: transferData.vehicleType,
                        vehicleCategory: transferData.vehicleCategory,
                        vehicleCode: transferData.vehicleCode,
                        brand: transferData.brand,
                        model: transferData.model,
                        route: transferData.route,
                        routes: transferData.routes,
                        totalPrice: transferData.pricing.totalPrice,
                        currency: transferData.pricing.currency,
                        currencySymbol: transferData.pricing.currency.symbol,
                        isRoundTrip: transferData.pricing.isRoundTrip || transferData.isMultipleWay,
                        isMultipleWay: transferData.isMultipleWay,
                        flightInfo: bookingData,
                        offerKey: transferData.offerKey,
                        maxPassengers: transferData.maxPassengers,
                        baggageCapacity: transferData.baggageCapacity,
                        image: transferData.image,
                        provider: transferData.provider
                    };
                    onAddToCart(cartItem);
                }

                handleCloseModal();
            } else {
                throw new Error(response.data.message || 'Failed to add transfer to cart');
            }

        } catch (error) {
            console.error('Error adding transfer to cart:', error);
            
            let errorMessage = 'Failed to add transfer to cart. Please try again.';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }

            Swal.fire({
                title: 'Error!',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="card mb-4 transfer-card">
            <div className="card-body">
                <div className="row">
                    {/* Vehicle Image */}
                    <div className="col-lg-4 col-md-5">
                        <div className="transfer-img position-relative">
                            {imageError ? (
                                <div 
                                    className="img-placeholder d-flex align-items-center justify-content-center rounded"
                                    style={{ 
                                        width: "100%", 
                                        height: "200px", 
                                        backgroundColor: "#f8f9fa",
                                        border: "2px dashed #dee2e6",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleBookNow()}
                                >
                                    <div className="text-center">
                                        <FaCar size={40} className="text-muted mb-2" />
                                        <div className="text-muted small">
                                            {transferData.name}
                                        </div>
                                        {transferData.brand && transferData.model && (
                                            <div className="text-muted" style={{ fontSize: '11px' }}>
                                                {transferData.brand.name} {transferData.model.name}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <img 
                                    src={transferData.image} 
                                    alt={transferData.name}
                                    className="img-fluid rounded"
                                    style={{ 
                                        width: "100%", 
                                        height: "200px", 
                                        objectFit: "cover",
                                        cursor: "pointer"
                                    }}
                                    onError={() => setImageError(true)}
                                    onClick={() => handleBookNow()}
                                />
                            )}
                            
                            {/* Vehicle Category Badge */}
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className={`badge bg-${getCategoryColor(transferData.vehicleCategory)} d-flex align-items-center gap-1`}>
                                    {getVehicleIcon(transferData.vehicleType)}
                                    {transferData.vehicleCategory}
                                </span>
                            </div>
                            
                            {/* Vehicle Code Badge */}
                            <div className="position-absolute top-0 end-0 m-2">
                                <span className="badge bg-dark">
                                    {transferData.vehicleCode}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Transfer Details */}
                    <div className="col-lg-8 col-md-7">
                        <div className="transfer-content h-100 d-flex flex-column">
                            
                            {/* Header */}
                            <div className="transfer-header mb-3">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div className="transfer-name-section">
                                        <h5 className="transfer-name mb-1">
                                            <span className="text-primary">
                                                {transferData.name}
                                            </span>
                                        </h5>
                                        {/* Brand & Model Info */}
                                        {transferData.brand && transferData.model && (
                                            <small className="text-muted d-block">
                                                {transferData.brand.name} {transferData.model.name} • {transferData.vehicleCategory}
                                            </small>
                                        )}
                                    </div>
                                    
                                    {/* Capacity Info */}
                                    <div className="capacity-info d-flex align-items-center gap-2">
                                        <span className="badge bg-info d-flex align-items-center gap-1">
                                            <FaUsers size={12} />
                                            {transferData.maxPassengers} passengers
                                        </span>
                                        <span className="badge bg-secondary d-flex align-items-center gap-1">
                                            <FaSuitcase size={12} />
                                            {transferData.baggageCapacity} bags
                                        </span>
                                    </div>
                                </div>
                                
                                {/* Route Info */}
                                <div className="route-info mb-2">
                                    {transferData.isMultipleWay ? (
                                        // Multiple routes (round trip)
                                        <div className="routes-container">
                                            {transferData.routes.map((route, index) => (
                                                <div key={index} className="d-flex align-items-center gap-2 mb-1">
                                                    <FaRoute className="text-primary" size={14} />
                                                    <span className="fw-medium">{route.from.name}</span>
                                                    <span className="text-muted">→</span>
                                                    <span className="fw-medium">{route.to.name}</span>
                                                    <span className="badge bg-light text-dark ms-2">
                                                        {route.type === 'departure' ? 'Departure' : 'Return'}
                                                    </span>
                                                    <small className="text-muted ms-2">
                                                        ({formatDate(route.date)})
                                                    </small>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        // Single route (one way)
                                        <div className="d-flex align-items-center gap-2">
                                            <FaRoute className="text-primary" size={14} />
                                            <span className="fw-medium">{transferData.route?.from?.name}</span>
                                            <span className="text-muted">→</span>
                                            <span className="fw-medium">{transferData.route?.to?.name}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Date & Passengers */}
                                <div className="d-flex align-items-center gap-3 mb-2">
                                    <div className="d-flex align-items-center text-muted">
                                        <FaClock className="me-1" size={12} />
                                        <small>{formatDate(transferData.dates.departureDate)}</small>
                                    </div>
                                    <div className="d-flex align-items-center text-muted">
                                        <FaUsers className="me-1" size={12} />
                                        <small>{transferData.passengers.total} passenger{transferData.passengers.total > 1 ? 's' : ''}</small>
                                        {transferData.passengers.adult > 0 && (
                                            <small className="ms-1">({transferData.passengers.adult} adult{transferData.passengers.adult > 1 ? 's' : ''})</small>
                                        )}
                                        {transferData.passengers.child > 0 && (
                                            <small className="ms-1">({transferData.passengers.child} child{transferData.passengers.child > 1 ? 'ren' : ''})</small>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Vehicle Features */}
                            <div className="vehicle-features mb-3 flex-grow-1">
                                <div className="row">
                                    <div className="col-6">
                                        <div className="feature-item d-flex align-items-center mb-2">
                                            <FaCheck className="text-success me-2" size={12} />
                                            <small>Professional Driver</small>
                                        </div>
                                        <div className="feature-item d-flex align-items-center mb-2">
                                            <FaCheck className="text-success me-2" size={12} />
                                            <small>Air Conditioning</small>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="feature-item d-flex align-items-center mb-2">
                                            <FaCheck className="text-success me-2" size={12} />
                                            <small>Door to Door Service</small>
                                        </div>
                                        <div className="feature-item d-flex align-items-center mb-2">
                                            <FaCheck className="text-success me-2" size={12} />
                                            <small>Free Cancellation</small>
                                        </div>
                                    </div>
                                </div>

                                {/* Round Trip Info */}
                                {(transferData.pricing.isRoundTrip || transferData.isMultipleWay) && (
                                    <div className="round-trip-info mt-2">
                                        <div className="alert alert-info py-2 mb-0">
                                            <small>
                                                <strong>Round Trip:</strong> 
                                                {transferData.isMultipleWay ? (
                                                    <span> Multiple destinations included</span>
                                                ) : transferData.dates.returnDate ? (
                                                    <span> Return on {formatDate(transferData.dates.returnDate)}</span>
                                                ) : (
                                                    <span> Return trip included</span>
                                                )}
                                            </small>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div className="transfer-footer d-flex justify-content-between align-items-center mt-auto">
                                {/* Price */}
                                <div className="price-info">
                                    <div className="d-flex align-items-baseline">
                                        {transferData.pricing.basePrice !== transferData.pricing.totalPrice && (
                                            <span className="text-muted text-decoration-line-through me-2">
                                                {transferData.pricing.currency.symbol}{transferData.pricing.basePrice}
                                            </span>
                                        )}
                                        <span className="h4 text-primary fw-bold mb-0">
                                            {transferData.pricing.currency.symbol}{transferData.pricing.totalPrice}
                                        </span>
                                        <small className="text-muted ms-1">{transferData.pricing.currency.code}</small>
                                    </div>
                                    <small className="text-muted">
                                        {transferData.pricing.isRoundTrip || transferData.isMultipleWay ? 'Round trip price' : 'One way price'}
                                    </small>
                                </div>

                                {/* Action Buttons */}
                                <div className="action-buttons">
                                    <button 
                                        className="btn btn-primary w-100"
                                        onClick={handleBookNow}
                                    >
                                        <FaPlane className="me-2" />
                                        Book Transfer
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Booking Modal */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header border-bottom">
                                <h5 className="modal-title d-flex align-items-center">
                                    <FaPlane className="text-primary me-2" />
                                    Transfer Booking Information
                                </h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            
                            <div className="modal-body">
                                {/* Transfer Summary */}
                                <div className="transfer-summary mb-4 p-3 bg-light rounded">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="flex-grow-1">
                                            <h6 className="mb-2">{transferData.name}</h6>
                                            {transferData.brand && transferData.model && (
                                                <small className="text-muted d-block mb-2">
                                                    {transferData.brand.name} {transferData.model.name} • {transferData.vehicleCategory}
                                                </small>
                                            )}
                                            
                                            {transferData.isMultipleWay ? (
                                                // Multiple routes summary
                                                <div className="routes-summary">
                                                    {transferData.routes.map((route, index) => (
                                                        <div key={index} className="route-item mb-1">
                                                            <small className="text-muted d-block">
                                                                <strong>{route.type === 'departure' ? 'Departure:' : 'Return:'}</strong> {route.from.name} → {route.to.name}
                                                                <span className="ms-2">({formatDate(route.date)})</span>
                                                            </small>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                // Single route summary
                                                <small className="text-muted">
                                                    {transferData.route?.from?.name} → {transferData.route?.to?.name}
                                                </small>
                                            )}
                                        </div>
                                        <div className="text-end">
                                            <div className="h5 text-primary mb-0">
                                                {transferData.pricing.currency.symbol}{transferData.pricing.totalPrice}
                                            </div>
                                            <small className="text-muted">
                                                {transferData.pricing.isRoundTrip || transferData.isMultipleWay ? 'Round trip' : 'One way'}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                {/* Pickup Time Information */}
                                <div className="pickup-info mb-4">
                                    <h6 className="text-primary mb-3">
                                        <FaClock className="me-2" />
                                        Pickup Time Information
                                    </h6>
                                    
                                    <div className="alert alert-info">
                                        <div className="mb-3">
                                            <strong>Please provide the following information, which is absolutely necessary for your transportation service reservation.</strong>
                                        </div>
                                        <div className="mb-3">
                                            In case of errors in the information, the supplier is not responsible for incorrect service delivery and cancellation/no-show fees may be charged from you.
                                        </div>
                                        <div className="mb-3">
                                            Please note that the requested pickup time option is <strong>NOT APPLICABLE for shared transportation services that INCLUDE A PORT</strong>.
                                        </div>
                                        <div className="mb-3">
                                            Customers should call the supplier to confirm the pickup time.
                                        </div>
                                        <div>
                                            <strong>Contact information can be found on the ticket.</strong>
                                        </div>
                                    </div>
                                </div>

                                {/* Flight Information Form */}
                                <form>
                                    <div className="row">
                                        {/* Arrival Flight Info */}
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-medium">
                                                    <FaPlane className="me-2 text-primary" />
                                                    Flight Number {transferData.pricing.isRoundTrip ? '(Arrival)' : ''}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="e.g. TK123"
                                                    value={bookingData.flightNumber}
                                                    onChange={(e) => handleInputChange('flightNumber', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-medium">
                                                    <FaClock className="me-2 text-primary" />
                                                    Flight Arrival Time {transferData.pricing.isRoundTrip ? '(Arrival)' : ''}
                                                </label>
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={bookingData.arrivalTime}
                                                    onChange={(e) => handleInputChange('arrivalTime', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Round Trip Additional Fields */}
                                    {(transferData.pricing.isRoundTrip || transferData.isMultipleWay) && (
                                        <>
                                            <hr className="my-4" />
                                            <h6 className="text-primary mb-3">
                                                <FaPlane className="me-2" />
                                                Return Flight Information
                                            </h6>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label fw-medium">
                                                            <FaPlane className="me-2 text-primary" />
                                                            Flight Number (Departure)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="e.g. TK456"
                                                            value={bookingData.departureFlightNumber}
                                                            onChange={(e) => handleInputChange('departureFlightNumber', e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label fw-medium">
                                                            <FaClock className="me-2 text-primary" />
                                                            Flight Departure Time
                                                        </label>
                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            value={bookingData.departureTime}
                                                            onChange={(e) => handleInputChange('departureTime', e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </form>
                            </div>
                            
                            <div className="modal-footer border-top">
                                <button 
                                    type="button" 
                                    className="btn btn-outline-secondary"
                                    onClick={handleCloseModal}
                                    disabled={isSubmitting}
                                >
                                    <FaTimes className="me-2" />
                                    Cancel
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-primary"
                                    onClick={handleConfirmBooking}
                                    disabled={isSubmitting}
                                >
                                    <FaCheck className="me-2" />
                                    {isSubmitting ? 'Adding to Cart...' : 'Add to Cart'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
} 